import { SengiColors } from "../../utils/SengiColors";
import { useTranslation } from "react-i18next";

export const handleShowToast = (idName:string, timeout:number=5000) => {
    let toast = document.getElementById(idName);
    if (toast) {
        const id = `#${idName}`;
        $(id).show();
        toast.style.display = 'block';
        toast.style.zIndex = '500';

        setTimeout(() => {
            if(!toast) return;
            $(id).hide();
            toast.style.display = 'none';
            toast.style.zIndex = '';
        }, timeout);
    }
};

export interface SimpleToastProps {
    id:string;
    classname?: string;
    role? : string;
    header: boolean;
    headerText?: string;
    headerClass?: string;
    headerIcon?: string;
    headerIconClass?: string;
    headerSmallText?:string;
    bodyClass?: string;
    bodyText:string;
    width?: string;
    styles?: React.CSSProperties;
};

export const SimpleToast = ({
    id,
    width,
    classname,
    role,
    header,
    headerClass,
    headerIcon,
    headerIconClass,
    headerText,
    headerSmallText,
    bodyClass,
    bodyText,
    styles
}:SimpleToastProps) =>{
    return(
        <div 
            className={`toast ${classname ?? ''}`} 
            id={id} role={`${role ?? 'alert'}`} 
            aria-live="assertive" aria-atomic="true" 
            style={{
                ...styles,
                width: width
            }}
        >
            { header ?
                <div className={`toast-header ${headerClass ?? ''}`}>
                    { headerIcon ?
                        <img src={headerIcon} className={`${headerIconClass ?? 'rounded me-2'}`} alt=""/>
                        : <></>
                    }
                    <strong className="me-auto">{headerText}</strong>
                    { headerSmallText ?
                        <small>{headerSmallText}</small>
                        : <></>
                    }
                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                : <></>
            }
            
            <div className={`toast-body ${bodyClass ?? ''}`}>
                {bodyText}
            </div>
        </div>
    )
};

interface SpecificToastProps {
    id:string;
    text?: string;
}

export const DownloadStartToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.downloadStart')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_flieder, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};
export const DownloadFailedToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.downloadFailed')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_error, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};

export const InfoUploadDataToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.uploadStart')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_flieder, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};
export const InfoUploadDataFailedToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.uploadFailed')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_error, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};
export const InfoOpenDataToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.openProjectStart')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_flieder, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};
export const InfoOpenDataFailedToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.openProjectFailed')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_error, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};
export const InfoDeleteDataToast = ({
    id,
    text
}:SpecificToastProps) => {
    const {t} = useTranslation('common')
    return(
        <SimpleToast
            id={id}
            header={false}
            bodyText={text ?? t('toasts.deleteProject')}
            bodyClass='text-center h5'
            classname='position-absolute top-0 border-dark text-dark'
            styles={{background: SengiColors.sng_flieder, minWidth:'fit-content', width: 150, right: "calc(50% - 150px)"}}
        />
    )
};
            